import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const campaignHeroBonus = {
    bonusPercent: '275',
    bonusAmount: '$3,000'
};
export const campaignHeroFeatures = [
    {
        icon: cfgToThemeCdnPath('/top-section/campaign-hero/milestone-1.svg'),
        label: Verbiage.sky_high_limits
    },
    {
        icon: cfgToThemeCdnPath('/top-section/campaign-hero/milestone-2.svg'),
        label: Verbiage.highest_rtp
    },
    {
        icon: cfgToThemeCdnPath('/top-section/campaign-hero/milestone-3.svg'),
        label: Verbiage.instant_payouts
    }
];
export const campaignHeroPromoCards = [
    {
        title: Verbiage.casino,
        icon: 'MobileCasinoIcon',
        borderColor: 'var(--color-highlight-4)',
        backgroundImage: cfgToThemeCdnPath('/top-section/campaign-hero/casino-card.png'),
        linkUrl: '/casino'
    },
    {
        title: Verbiage.sports,
        icon: 'MobileSportsIcon',
        borderColor: 'var(--color-accent-500)',
        backgroundImage: cfgToThemeCdnPath('/top-section/campaign-hero/sports-card.png'),
        linkUrl: '/sports'
    }
];
